/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
import { combineReducers } from 'redux';
import userReducer from './userReducer';
import turnReducer from './turnReducer';
import infoReducer from './infoReducer';
import doctorReducer from './doctorReducer';
import healthInsuranceReducer from './healthInsuranceReducer';
import notificationReducer from './notificationReducer';
import questionReducer from './questionReducer';

const MainReducer = combineReducers({
  userReducer,
  turnReducer,
  infoReducer,
  doctorReducer,
  healthInsuranceReducer,
  notificationReducer,
  questionReducer,
});
const rootReducer = (state, action) => MainReducer(state, action);
export default rootReducer;
